import React from 'react';
import PropTypes from 'prop-types';

import SubscriptionTableItem from '../molecules/SubscriptionTableItem';

const UserInfoTable = ({ tripTotalDays, schedule, outboundSessionFlight, inboundSessionFlight }) => {
  return (
    <div className="userInfoTableContainer">
      <table>
        <thead>
          <tr>
            <th style={{ width: 173 }}>利用日</th>
            <th style={{ width: 488, borderRight: 'none' }}>旅程</th>
            <th style={{ width: 275, borderLeft: 'none' }}></th>
          </tr>
        </thead>
        <tbody>
          {schedule && schedule.map((s, i) => {
            const dateDisplay = s.date.format('YYYY年M月D日');

            const outboundFlight = i === 0 ? outboundSessionFlight : null;
            const inboundFlight = i === tripTotalDays - 1 ? inboundSessionFlight : null;

            const index = i + 1;

            const { plan } = s;

            return (
              <SubscriptionTableItem
                key={index}
                index={i + 1}
                outboundFlight={outboundFlight}
                inboundFlight={inboundFlight}
                dateDisplay={dateDisplay}
                plan={plan}
                handleFlightChange={() => {}}
                handlePlanChange={() => {}}
                handlePlanDelete={() => {}}
                cantChangeHotel={true}
                cantDeleteHotel={true}
                handleUpdateCheckin={() => {}}
                finalConfirm={true}
                hideCheckin={!(plan && plan.firstDay)}
                handleUpdateQuestion={() => {}}
                showQuestions={!!(plan && plan.firstDay)}
                hideMessage={!(plan && plan.firstDay)}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

UserInfoTable.propTypes = {
  tripTotalDays: PropTypes.number.isRequired,
  schedule: PropTypes.array.isRequired,
  outboundSessionFlight: PropTypes.object.isRequired,
  inboundSessionFlight: PropTypes.object.isRequired,
};

export default UserInfoTable;